import React from 'react';
import styles from './LandingPage.module.css';
import logo from "../../assets/images/Horizontal_White.png";
import RegistrationForm from "../../components/RegistrationForm/RegistrationForm";
import {useSearchParams} from 'react-router-dom';

function LandingPage() {
  const [searchParams] = useSearchParams();
  const referralCode = searchParams.get('referral_code')

  return (
    <div className={styles.pageContainer}>
      <header className={styles.brandBanner}>
        <img src={logo} alt="MedXCom" className={styles.brandLogo}/>
      </header>
      <div className={styles.titleBlock}>
        <h1 className={styles.pageTitle}>Customer Registration</h1>
        <p className={styles.pageSubtitle}>Let's get your practice set up — it only takes a few minutes.</p>
      </div>
      <main className={styles.mainContent}>
        <RegistrationForm referralCode={referralCode}/>
      </main>
    </div>
  );
}

export default LandingPage;
